
define('text!templates/appMain/privilegedMain/composer/forms/qualityScore/questionScore.html',[],function () { return '<!-- ko if: evaluationScore.failedKillQuestionIds.indexOf(questionScore.id) >= 0 -->\n    <div class="qm-question-score">\n        <span data-bind="lString: &apos;composer.evaluations.scoring.failedKillQuestion&apos;"></span>\n    </div>\n<!-- /ko -->';});

